import api from "../config/api";

export const fetchCustomerAddresses = async () => {
  const res = await api.get(`/address/`);
  return res.data.data;
};

export const fetchCustomerAddressById = async (id) => {
  const res = await api.get(`/address/?id=${id}`);
  return res.data.data;
};

export const fetchCustomerAddressByCustId = async (id) => {
  const res = await api.get(`/address/?customerId=${id}`);
  return res.data.data;
};

export const createCustomerAddress = async (data) => {
  const res = await api.post(`/address/`, data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data.data;
};

export const updateCustomerAddress = async (id, data) => {
  const res = await api.put(`/address/?id=${id}`, data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data.data;
};

export const deleteCustomerAddress = async (id) => {
  const res = await api.delete(`/address/?id=${id}`);
  return res.data.data;
};
